// extracted by mini-css-extract-plugin
export default {"buttonContainer":"_5XLLx","alignToEdge":"_43wZ8","buttonIcon":"Dqci0","buttonCaption":"_5tVfA","buttonSpacer":"-Pti9"};